import { Injectable } from '@angular/core';
import { AuthConfiguration } from '../modules/auth.configuration';
export class OidcSecurityCommon {
private storage: any;

    storage_access_token = 'authorizationData';
    storage_id_token = 'authorizationDataIdToken';
    storage_is_authorized = '_isAuthorized';
    storage_user_data = 'userData';
    storage_auth_nonce = 'authNonce';
    storage_auth_state_control = 'authStateControl';
    storage_well_known_endpoints = 'wellknownendpoints';
/**
 * @param {?} authConfiguration
 */
constructor(private authConfiguration: AuthConfiguration) {
        if (typeof Storage !== 'undefined') { this.storage = sessionStorage; } //localStorage;
    }
/**
 * @param {?} key
 * @return {?}
 */
retrieve(key: string): any {
        if (this.storage) {
            return JSON.parse(this.storage.getItem(key));
        }

        return;
    }
/**
 * @param {?} key
 * @param {?} value
 * @return {?}
 */
store(key: string, value: any) {
        if (this.storage) {
            this.storage.setItem(key, JSON.stringify(value));
        }
    }
/**
 * @return {?}
 */
resetStorageData() {
        this.store(this.storage_access_token, '');
        this.store(this.storage_id_token, '');
        this.store(this.storage_is_authorized, false);
        this.store(this.storage_user_data, '');
    }
/**
 * @return {?}
 */
getAccessToken(): any {
        return this.retrieve(this.storage_access_token);
    }
/**
 * @param {?} message
 * @return {?}
 */
logError(message: any) {
        console.error(message);
    }
/**
 * @param {?} message
 * @return {?}
 */
logWarning(message: any) {
        if (this.authConfiguration.log_console_warning_active) {
            console.warn(message);
        }
    }
/**
 * @param {?} message
 * @return {?}
 */
logDebug(message: any) {
        if (this.authConfiguration.log_console_debug_active) {
            console.log(message);
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AuthConfiguration, },
];
}

function OidcSecurityCommon_tsickle_Closure_declarations() {
/** @type {?} */
OidcSecurityCommon.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OidcSecurityCommon.ctorParameters;
/** @type {?} */
OidcSecurityCommon.prototype.storage;
/** @type {?} */
OidcSecurityCommon.prototype.storage_access_token;
/** @type {?} */
OidcSecurityCommon.prototype.storage_id_token;
/** @type {?} */
OidcSecurityCommon.prototype.storage_is_authorized;
/** @type {?} */
OidcSecurityCommon.prototype.storage_user_data;
/** @type {?} */
OidcSecurityCommon.prototype.storage_auth_nonce;
/** @type {?} */
OidcSecurityCommon.prototype.storage_auth_state_control;
/** @type {?} */
OidcSecurityCommon.prototype.storage_well_known_endpoints;
/** @type {?} */
OidcSecurityCommon.prototype.authConfiguration;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
